import styles from "@/components/modal/paywall-modal/styles/paywall-modal.module.scss";
import Pricing from "@/components/common/pricing";
import TextButton from "@/components/common/text-button";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { useMobile } from "@/hooks/use-responsive";

export const paywallStorageKey = "paywallModalShown";

const PaywallModal = () => {
  const { hideModal } = useGlobalModalContext();
  const { isMobile } = useMobile();

  return (
    <div className={styles.wrapper}>
      {!isMobile && (
        <div className={styles.header_text}>
          What plan do you want to start with?
        </div>
      )}
      <Pricing />
      <div className={styles.skip_button_wrapper}>
        <TextButton
          isEnabled={true}
          text={"OR CONTINUE FOR FREE"}
          textColor={"#F9A825"}
          handleClick={hideModal}
        />
      </div>
    </div>
  );
};

export default PaywallModal;
